import React, { useContext, useEffect, useState } from 'react';
import debounce from 'lodash.debounce';

import { isDesktop, isMobile, isTabletOrGreater } from '../utils/media';
import { isWindowAvailable } from '../utils/browserObjectsAvailability';
import { useEffectOnce } from '../hooks/useEffectOnce';

export const useBreakpoint = (checkIfPassesBreakpoint) => {
  const [passesBreakpoint, setBreakpoint] = useState(checkIfPassesBreakpoint);

  useEffect(() => {
    const onResize = () => {
      setBreakpoint(checkIfPassesBreakpoint());
    };
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  });

  return passesBreakpoint;
};

const DEFAULT_BREAKPOINTS_VALUES = {
  isMobile: true,
  isTabletOrGreater: false,
  isDesktop: isWindowAvailable() && isDesktop(),
  isSet: isWindowAvailable(),
};

const BreakpointsContext = React.createContext(DEFAULT_BREAKPOINTS_VALUES);

const checkBreakpoints = () => ({
  isMobile: isMobile(),
  isDesktop: isDesktop(),
  isTabletOrGreater: isTabletOrGreater(),
  isSet: isWindowAvailable(),
});

export const BreakpointsContextProvider = ({ children }) => {
  const [breakpointsData, setBreakpointsData] = useState(DEFAULT_BREAKPOINTS_VALUES);

  useEffectOnce(() => {
    setBreakpointsData(checkBreakpoints);
  });

  useEffect(() => {
    const onResize = debounce(() => {
      setBreakpointsData(checkBreakpoints);
    }, 150);
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  });

  return <BreakpointsContext.Provider value={breakpointsData}>{children}</BreakpointsContext.Provider>;
};

export const useBreakpointsContext = () => {
  return useContext(BreakpointsContext);
};
